import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class VendorsSearch extends BaseModel {
  customer_no = null;
  first_name = null;
  last_name = null;
  company_name = null;
  email = null;
  address_info = null;
  client_tier = null;
  identity_verification = null;

  rules = {};

  attributeLabels = {
    customer_no: i18n.t("Customer"),
    first_name: i18n.t("First Name"),
    last_name: i18n.t("Last Name"),
    company_name: i18n.t("Company Name"),
    address_info: i18n.t("Address"),
    email: i18n.t("Email"),
    has_unsettled_sold_lots: i18n.t('Has Unsettled Sold Lots'),
    identity_verification: i18n.t('Identity Verification'),

  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.customer

    if (!this.identity_verification) {
      delete data.identity_verification;
    }

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);
        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(VendorsSearch);
